"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconMiscDocs = function SvgIconMiscDocs(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "misc docs icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Misc Docs Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.94 24.526c.895 0 1.62.726 1.62 1.62v6.48h6.48a1.62 1.62 0 010 3.239h-6.48v6.119a1.62 1.62 0 01-3.239 0v-6.12h-6.119a1.62 1.62 0 010-3.239h6.12v-6.479c0-.894.724-1.62 1.619-1.62zM30.899 4a5.618 5.618 0 015.607 5.391l.005.22v8.628a1.403 1.403 0 01-2.8.135l-.006-.135V9.61a2.81 2.81 0 00-2.635-2.8l-.17-.005H13.65a2.81 2.81 0 00-2.8 2.635l-.005.17V34.3a2.81 2.81 0 002.635 2.8l.17.006h4.692a1.403 1.403 0 01.135 2.8l-.135.006H13.65a5.618 5.618 0 01-5.607-5.392l-.004-.22V9.611a5.618 5.618 0 015.391-5.607L13.65 4h17.247zm-7.076 19.64a1.403 1.403 0 01.135 2.799l-.135.006h-8.776a1.403 1.403 0 01-.135-2.799l.135-.006h8.776zm5.674-5.612a1.403 1.403 0 01.135 2.8l-.135.006h-14.45a1.403 1.403 0 01-.135-2.8l.135-.006h14.45zm-14.45-5.611h14.45a1.403 1.403 0 01.135 2.8l-.135.006h-14.45a1.403 1.403 0 01-.135-2.8l.135-.006h14.45z"
  }));
};

var _default = SvgIconMiscDocs;
exports.default = _default;